module.exports = __webpack_public_path__ + "img/BH.2366200b.svg";